import { createContext, useContext } from 'react';
import type { RouteTheme } from '@/shared/config/designTokens';

/** Published by FmThemeProvider, the route theme owner. */
export const RouteThemeContext = createContext<RouteTheme | undefined>(undefined);

/** The declared route theme, for chrome that must match it (the top bar). */
export function useRouteTheme(): RouteTheme | undefined {
  return useContext(RouteThemeContext);
}
